import { Presence } from 'Roblox';
import { abbreviateNumber } from 'core-utilities';
import { GameSortId } from '../constants/eventStreamConstants';
import { TGetFriendsResponse } from '../types/bedev1Types';

export const getInGameFriends = (
  friendData: TGetFriendsResponse[],
  universeId: number
): TGetFriendsResponse[] => {
  return friendData.filter(
    friend =>
      friend.presence?.universeId === universeId &&
      friend.presence?.userPresenceType === Presence.PresenceTypes.InGame
  );
};

export const getVotePercentage = (upvotes: number, downvotes: number): string | undefined => {
  let percentUp = 0;
  if (!Number.isNaN(upvotes) && !Number.isNaN(downvotes)) {
    if (upvotes === 0 && downvotes === 0) {
      return undefined;
    }
    if (upvotes === 0 && downvotes !== 0) {
      percentUp = 0;
    } else if (upvotes !== 0 && downvotes === 0) {
      percentUp = 100;
    } else {
      percentUp = Math.floor((upvotes / (upvotes + downvotes)) * 100);
      percentUp = percentUp > 100 ? 100 : percentUp;
    }
  }
  return `${percentUp}%`;
};

export const getGameSortId = (sortName?: string): number => {
  let sortId;
  if (sortName) {
    sortId = GameSortId[sortName as keyof typeof GameSortId];
  }

  if (sortName?.toLowerCase().includes('curated_')) {
    sortId = GameSortId.Curated;
  }

  if (sortId === undefined) {
    sortId = GameSortId.Default;
  }
  return sortId;
};

export const parseEventParams = (params: Record<string, any>): Record<string, string | number> => {
  return Object.keys(params).reduce<Record<string, string | number>>((acc, key) => {
    if (typeof params[key] === 'object' && params[key]) {
      acc[key] = JSON.stringify(params[key]);
    }

    if (typeof params[key] === 'number') {
      acc[key] = params[key] as number;
    }

    if (typeof params[key] === 'string') {
      acc[key] = encodeURIComponent(params[key]);
    }

    if (typeof params[key] === 'boolean') {
      acc[key] = params[key] ? 1 : 0;
    }

    return acc;
  }, {});
};

export const { getAbbreviatedValue } = abbreviateNumber;

export default {
  getGameSortId,
  parseEventParams,
  getInGameFriends,
  getVotePercentage,
  getAbbreviatedValue
};
